<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Month sales (second normalization)
            </v-row>
            <v-divider />
            <!--month sales tab-->
            <div v-if="monthSales.length > 0">
                <v-expansion-panels focusable v-model="tab">
                    <v-expansion-panel v-for="(item, index) in sales_arr" :key="item.id">
                        <v-expansion-panel-header class="font-weight-bold secondary--text">
                            <!-- month-->
                            Month {{ index + 1 }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="body-2">
                            <!--table head-->
                            <v-row class="subtitle-2" no-gutters>
                                <v-col cols="1" class="text-left">Segment</v-col>
                                <v-divider vertical></v-divider>
                                <v-col cols="1" class="text-center">Offered for</v-col>
                                <v-divider vertical></v-divider>

                                <v-col v-for="seg in item" :key="seg.segment.id">
                                    <v-row class="subtitle-2" no-gutters>
                                        <v-col class="text-center">
                                            {{ seg.segment.name }}
                                        </v-col>
                                        <v-divider vertical></v-divider>
                                    </v-row>
                                </v-col>
                                <v-col cols="1" class="text-center">Total</v-col>
                                <v-divider vertical></v-divider>
                                <v-col cols="1" class="text-center">Delta</v-col>
                                <v-divider vertical></v-divider>
                            </v-row>
                            <v-divider />
                            <v-row class="subtitle-2" no-gutters>
                                <v-col cols="1" class="text-left">Product</v-col>
                                <v-divider vertical></v-divider>
                                <v-col cols="1" class="text-center">sales</v-col>
                                <v-divider vertical></v-divider>
                                <v-col v-for="(seg, index) in item" :key="index">
                                    <v-row class="subtitle-2" no-gutters>
                                        <v-col class="text-center">max demand</v-col>
                                        <v-divider vertical></v-divider>
                                        <v-col class="text-center">sales</v-col>
                                        <v-divider vertical></v-divider>
                                    </v-row>
                                </v-col>
                                <v-col cols="1" class="text-center"></v-col>
                                <v-divider vertical></v-divider>
                                <v-col cols="1" class="text-center"></v-col>
                                <v-divider vertical></v-divider>
                            </v-row>
                            <v-divider />
                            <!--- table month sales first normalization-->
                            <v-row v-for="product in products" :key="product.productId" no-gutters>
                                <v-col cols="1" class="text-left">
                                    {{ product.trademark.name }} {{ product.model }}
                                </v-col>
                                <v-col cols="1" class="text-center">
                                    {{ localeNumber(offeredSales(product.productId, index)) }}
                                </v-col>
                                <v-col v-for="seg in item" :key="seg.segment.id">
                                    <v-row no-gutters>
                                        <v-col class="text-center">
                                            {{ localeNumber(maxDemand(product.productId, seg.segment.id, index)) }}
                                        </v-col>
                                        <v-col class="text-center">
                                            {{ localeNumber(sales(product.productId, seg.segment.id, index)) }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="1" class="text-center">
                                    {{ localeNumber(totalSales(product.productId, index)) }}
                                </v-col>
                                <v-col cols="1" class="text-center">
                                    {{ localeNumber(offeredSales(product.productId, index) - totalSales(product.productId, index)) }}
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <v-row v-else class="mt-4" justify="center">
                there are no sales yet
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue';
import { localeNumber } from '../../../functions/common';
export default {
    data() {
        return {
            tab: 0,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        monthSales() {
            return this.$store.getters.monthSales;
        },
        sales_arr() {
            const res = [];
            if (this.monthSales.length > 0) {
                for (let month = 0; month < 12; month++) {
                    res[month] = this.monthSales.filter((item) => item.month === month + 1);
                    const segments = [{
                        segment: res[month][0].segment,
                        models: [],
                    }];
                    res[month].forEach((item) => {
                        const inArr = segments.find((it) => it.segment.id === item.segmentId);
                        if (!inArr) {
                            segments.push({
                                segment: item.segment,
                                models: [item],
                            })
                        } else {
                            inArr.models.push(item)
                        }
                    });
                    res[month] = segments;
                }
            }
            //console.log(res)
            return res;
        },
        products() {
            const res = [];
            if (this.monthSales.length > 0) {
                this.monthSales.forEach((item) => {
                    const inArr = res.find((product) => product.productId === item.productId);
                    if (!inArr) {
                        res.push(item)
                    }
                });
            }
            //console.log(res)
            return res;
        },
    },
    methods: {
        localeNumber(number) {
            return localeNumber(number, this.locale)
        },
        maxDemand(productId, segmentId, month) {
            const matched_arr = this.sales_arr[month];
            const segment = matched_arr.find((item) => item.segment.id == segmentId);
            let max_demand = 0;

            const product = segment.models.find((prod) => prod.productId == productId);
            if (product) {
                max_demand = product.max_demand;
            }
            return max_demand;
        },
        sales(productId, segmentId, month) {
            const matched_arr = this.sales_arr[month];
            const segment = matched_arr.find((item) => item.segment.id == segmentId);
            let sales = 0;

            const product = segment.models.find((prod) => prod.productId == productId);
            if (product) {
                sales = product.sales_normalized;
            }
            return sales;
        },
        inventories(productId, segmentId, month) {
            const matched_arr = this.sales_arr[month];
            const segment = matched_arr.find((item) => item.segment.id == segmentId);
            let inventories = 0;

            const product = segment.models.find((prod) => prod.productId == productId);
            if (product) {
                inventories = product.inventories;
            }
            return inventories;
        },
        offeredSales(productId, month) {
            const matched_arr = this.sales_arr[month];
            let offeredSales = 0;
            matched_arr.forEach((item) => {
                const product = item.models.find((prod) => prod.productId == productId);
                if (product) {
                    offeredSales = product.offered_sale;
                }
            });
            return offeredSales;
        },
        totalSales(productId, month) {
            const matched_arr = this.sales_arr[month];
            let totalSales = 0;
            matched_arr.forEach((item) => {
                const products = item.models.filter((prod) => prod.productId == productId);
                if (products.length > 0) {
                    totalSales += products.reduce((sum, item) => {
                        return (sum+= item.sales_normalized);
                    }, 0);
                }
            });
            return totalSales;
        }
    },
    components: { Loader }
}
</script>
